// Configurações centralizadas da Ytech Soluções
// Todas as informações de contato e empresa em um único local

export const SITE_CONFIG = {
  company: {
    name: "Ytech Soluções",
    description: "Parceiro oficial Zebra Technologies e Extreme Networks",
    year: new Date().getFullYear(),
  },
  contact: {
    email: "jairo@ytechsolucoes.com",
    phone: "(92) 3307-0068",
    address:
      "Mirage Centro Comercial, Av. Desembargador João Machado nº 597 sala 04, Manaus - AM",
  },
  whatsapp: [
    {
      name: "Matheus Santana",
      role: "Analista de Suporte",
      number: "5592981100201",
      message:
        "Olá Matheus! Visitei o site da Ytech e gostaria de mais informações.",
    },
    {
      name: "Ygor Rafael",
      role: "Analista de Suporte",
      number: "5592981517495",
      message:
        "Olá Ygor! Visitei o site da Ytech e gostaria de mais informações.",
    },
    {
      name: "Zete Souza",
      role: "Analista de Suporte",
      number: "5592984702697",
      message:
        "Olá Zete! Visitei o site da Ytech e gostaria de mais informações.",
    },
  ],
  social: {
    // TODO: Preencher URLs reais quando disponíveis
    linkedin: "https://www.linkedin.com/company/ytechsolucoes",
    instagram: "https://www.instagram.com/ytechsolucoes",
  },
  api: {
    baseUrl:
      typeof window !== "undefined" &&
      typeof window.YTECH_API_BASE_URL === "string"
        ? window.YTECH_API_BASE_URL.trim().replace(/\/$/, "")
        : "",
    timeoutMs: 15000,
    turnstileSiteKey:
      typeof window !== "undefined" &&
      typeof window.YTECH_TURNSTILE_SITE_KEY === "string"
        ? window.YTECH_TURNSTILE_SITE_KEY.trim()
        : "0x4AAAAAAC137vArKofTnO_-",
  },
  maps: {
    embedUrl:
      "https://www.google.com/maps/embed/v1/place?key=AIzaSyAitB3x3iMhAV8i4gyPQ1FDkL_mYT4U-hk&q=Mirage+Centro+Comercial,Manaus&zoom=17",
    linkUrl:
      "https://www.google.com/maps/search/?api=1&query=Mirage+Centro+Comercial,Manaus",
  },
};

if (typeof window !== "undefined") {
  window.SITE_CONFIG = SITE_CONFIG;
}
